import {
  APPLICATION,
  SESSION_EXPIRE_URL,
  PRODUCT,
  MAGNOLIA_NEXT_API_URL,
} from "@/constants";
import logError from "@/utils/logger";

const fetchSessionExpireError = async () => {
  let pageJson: { title?: string; ctaButtonText?: string } | null = {};
  try {
    const fetchURL = `${MAGNOLIA_NEXT_API_URL}/${SESSION_EXPIRE_URL}/${PRODUCT}-${APPLICATION}`;
    const response = await fetch(fetchURL);
    if (!response.ok) {
      pageJson = {};
    }

    const res = await response.json();
    pageJson = {
      title: res.data.titleText,
      ctaButtonText: res.data.ctaButtonText1,
    };
  } catch (e) {
    logError(e as Error, { location: "fetchSessionExpire.tsx" });
    pageJson = null;
  }

  return pageJson;
};

export default fetchSessionExpireError;
